<template>
  <div class="w-52 overflow-hidden flex flex-col gap-y-1">
    <el-input
      v-model="state.params.keywords"
      clearable
      placeholder="关键字"
      @keyup.enter="onLoad()"
      @clear="onLoad()"
    >
      <template #suffix>
        <el-icon
          @click="onLoad()"
          color="#a2a2a2"
          title="搜索"
          class="font-bold cursor-pointer hover:opacity-60"
          ><Search
        /></el-icon>
      </template>
    </el-input>
    <div class="flex-1 overflow-y-auto">
      <el-tree
        style="max-width: 600px"
        :data="state.bmData"
        :props="{
          children: 'children',
          label: 'name',
        }"
        default-expand-all
        :expand-on-click-node="false"
        @node-click="onNodeClick"
      >
        <template #default="{ node, data }">
          <el-dropdown trigger="contextmenu">
            <div class="flex items-center gap-x-1">
              <li
                v-if="data.status != 1"
                class="text-white bg-red-400 rounded-sm"
                style="padding: 2px; font-size: 10px"
              >
                禁
              </li>
              <text :class="data.status != 1 ? 'text-gray-400' : ''">{{
                node.label
              }}</text>
            </div>
            <template #dropdown>
              <el-dropdown-menu
                style="--el-dropdown-menuItem-hover-fill: #f6f6f6"
              >
                <el-dropdown-item
                  v-if="!data.id"
                  class="!text-green-600"
                  @click="onLoad()"
                >
                  <template #icon>
                    <el-icon><Refresh /></el-icon>
                  </template>
                  <text>刷新</text>
                </el-dropdown-item>
                <el-dropdown-item
                  class="!text-blue-600"
                  @click="
                    state.selectPid = data.id;
                    delete state.selectId;
                    state.showInfo = true;
                  "
                  v-if="data.status == 1"
                >
                  <template #icon>
                    <el-icon><Plus /></el-icon>
                  </template>
                  <text>新增</text>
                </el-dropdown-item>
                <el-dropdown-item
                  class="!text-yellow-600"
                  @click="
                    state.selectId = data.id;
                    delete state.selectPid;
                    state.showInfo = true;
                  "
                >
                  <template #icon>
                    <el-icon color="#ca8a04"><Edit /></el-icon>
                  </template>
                  <text>修改</text>
                </el-dropdown-item>
                <el-dropdown-item @click="onDelete(data)" class="!text-red-600">
                  <template #icon>
                    <el-icon><Delete /></el-icon>
                  </template>
                  <text>删除</text>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-tree>
    </div>
  </div>

  <el-dialog
    v-model="state.showInfo"
    :title="state.selectId ? '编辑部门' : '新建部门'"
    class="c-el-dialog"
    width="500"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :pid="state.selectPid"
      :id="state.selectId"
      @close="
        (refresh) => {
          state.showInfo = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { department_delete, department_index } from "@/http/department";
import { onDeleteConfirm } from "@/utils/funcs";
import { companyName } from "@/utils/base";

import c_info from "./Info.vue";

export default {
  components: {
    c_info,
  },
  setup(props, { emit }) {
    const state = reactive({
      params: {
        tree: 1,
        limit: 0,
        sort_field: "sort",
        sort_value: "desc",
      },
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.bmData;

      department_index(state.params).then((res) => {
        if (res.status == 200)
          state.bmData = [
            {
              id: null,
              name: companyName,
              status: 1,
              children: res.data?.data?.list || [],
            },
          ];
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(department_delete, row.id, onLoad, {
        filed: "部门",
        name: row.name,
      });
    };

    const onNodeClick = (data) => {
      emit("node-change", data.id);
    };
    return { state, onLoad, onDelete, onNodeClick };
  },
};
</script>

<style lang="less" scoped></style>
